import React, { Component } from 'react';
import './index.scss';
import CustomBanner from '../../components/CustomBanner';
import Loader from '../loader';
import { ReactComponent as BarCode } from '../../assets/images/bar-code-icon.svg';
import BarCodeModal from '../../components/BarcodeModal';
import * as API from '../../configuration/apiconfig';
import { showAlert } from '../../components/showAlert';
import infoIcon from '../../assets/images/info-icon.svg';
import { formatShowTime } from '../../utils/DateTimeFormat';
import { handlePrintTicketUtil, getAllPayloads, calculateTotal } from '../../utils/printUtils';

class PickupTickets extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      barcodeModalSH: false,
      layoutName: 'shift',
      orderId: '',
      scanBarCodeBtnClick: false,
      manualBarCodeBtnClick: false,
      keyboardInputClickManually: false,
      loginErrorMsg: '',
      scanBarcodeLoaderMsg: 'Barcode scanning in progress',
      ticketsSummary: [],
      ticketsDataForTicketSummary: [],
      fnbDataForTicketSummary: [],
      bookingSummary: {},
    };
  }

  componentDidMount = () => {
    // TODO: Add initialization logic
    window.winvar = this;
  };

  handleBackBtn = () => {
    // TODO: Handle back navigation
    let getCinemaIdFromLocalstorage = localStorage.getItem('cinemaid');
    window.location.href = `/?cinemaid=${getCinemaIdFromLocalstorage}`;
  };

  closeIconClick = getFlow => {
    this.setState(
      {
        barcodeModalSH: false,
        orderId: '',
        scanBarCodeBtnClick: false,
        manualBarCodeBtnClick: false,
        keyboardInputClickManually: false,
      },
      () => {
        if (getFlow === 'scanBarcodeClose') {
          this.props.timerDecrement();
        }
      }
    );
  };

  keyBoardOnChange = input => {
    this.setState({
      orderId: input,
      loginErrorMsg: '',
    });
  };

  keyBoardOnKeyPress = button => {
    // Numeric keyboard only, no shift needed
    if (button === '{bksp}') {
      this.setState(prevState => ({
        orderId: prevState.orderId.slice(0, -1),
        loginErrorMsg: '',
      }));
    } else if (button === '{enter}') {
      if (!this.disableSubmitBtn()) {
        this.submitOrderId();
      }
    }
  };

  keyBoardHandleShift = () => {
    // Numeric keyboard only, no shift needed
  };

  clickKeyboardIcon = () => {
    this.setState(
      {
        keyboardInputClickManually: !this.state.keyboardInputClickManually,
      },
      () => {
        var getInputElem = document.getElementById('memberInput');
        if (getInputElem) {
          document.getElementById('memberInput').focus();
        }
      }
    );
  };

  GetCardInfo = scanData => {
    console.log(scanData, 'scanData----(.net function)');
    if (scanData) {
      this.setState(
        {
          orderId: scanData,
          scanBarcodeLoaderMsg: 'Fetching Order Info',
        },
        () => {
          window.callbackObj.callDisableBarcodeScan();
          this.submitOrderId();
        }
      );
    }
  };

  submitOrderId = async () => {
    this.setState({ loader: true });
    // console.log('Order ID submitted:', this.state.orderId);
    let getCinemaIdFromLocalstorage = localStorage.getItem('cinemaid');
    let data = {
      bookingId: this.state.orderId,
      cinemaId: getCinemaIdFromLocalstorage ? getCinemaIdFromLocalstorage : ''
    }
    await API.callEndpoint('POST', 'Bearer', '/order/v2/bookings/collectedStatus', data)
      .then(response => {
        console.log(response, 'response from bookings/collectedStatus');
        if (response.data?.code === 200) {
          showAlert({
            html: `<p>Sorry<span>${response.data?.message}</span></p>`,
            iconHtml: `<img src="/assets/images/info-icon.svg" alt="info" />`,
            showCancelButton: false,
            cancelButtonText: 'CANCEL',
            showConfirmButton: true,
            confirmButtonText: 'Okay',
            allowOutsideClick: false,
            allowEscapeKey: false,
            iconClasses: 'borderless',
            popupClasses: 'common-error-alert',
            onConfirm: () => { },
            onCancel: () => { },
          });
          this.setState({
            loader: false,
            scanBarCodeBtnClick: false,
            barcodeModalSH: this.state.manualBarCodeBtnClick,
            orderId: this.state.manualBarCodeBtnClick ? this.state.orderId : '',
          });
        } else {
          this.setState(
            {
              bookingSummary: response.data,
              loader: false,
              barcodeModalSH: false,
              orderId: '',
              scanBarCodeBtnClick: false,
              manualBarCodeBtnClick: false,
              keyboardInputClickManually: false,
            },
            () => this.processBookingDataAndPrint()
          );
        }
      })
      .catch(err => {
        console.log(err.error);
        this.setState({
          loader: false,
          loginErrorMsg: err.error || 'Failed to fetch order',
        });
      });
  };

  disableSubmitBtn = () => {
    var disabled = true;
    if (this.state.orderId !== '') {
      disabled = false;
    } else {
      disabled = true;
    }
    return disabled;
  };

  processBookingDataAndPrint = () => {
    this.setTicketsDataForTicketSummary(() => {
      this.setFnbDataForTicketSummary(() => {
        this.setTicketsSummary(() => {
          this.handlePrintTicket();
        });
      });
    });
  };

  setTicketsSummary = callback => {
    let ticketDetails = [];
    let subTotal = 0;

    this.state.bookingSummary.order_grouping?.forEach(ticket => {
      ticketDetails.push({
        description: ticket.description,
        quantity: ticket.quantity,
        valueBeforeTax: ticket.pricebeforetax,
      });
      subTotal = subTotal + ticket.pricebeforetax;
    });

    const tcktSummaryObj = {
      ticketDetails: ticketDetails,
      subTotal: this.state.bookingSummary.valuebeforetax || subTotal,
      taxValue: this.state.bookingSummary.taxValue || 0,
      grandTotal: this.state.bookingSummary.remainingOrderValue || 0,
      bookingFee: this.state.bookingSummary.bookingfeebeforetax || 0,
    };

    this.setState({ ticketsSummary: [tcktSummaryObj] }, callback);
  };

  setTicketsDataForTicketSummary = callback => {
    let tempOrderData = [];
    this.state.bookingSummary.order_grouping?.forEach(eachTicket => {
      if (eachTicket.type.toLowerCase() === 'ticket') {
        let eachTaxValue = (eachTicket.taxValue || 0) / eachTicket.quantity;
        let tempTicketObject = {
          description: eachTicket.description,
          unitprice: eachTicket.unitprice - eachTaxValue,
          qty: eachTicket.quantity,
        };
        tempOrderData.push(tempTicketObject);
      }
    });
    this.setState({ ticketsDataForTicketSummary: tempOrderData }, callback);
  };

  setFnbDataForTicketSummary = callback => {
    var fnbDataForTicketSummary = [];
    this.state.bookingSummary.order_grouping?.forEach(eachItem => {
      if (eachItem.type.toLowerCase() === 'fnb') {
        var tempItemObject = {
          description: eachItem.description,
          qty: eachItem.quantity,
          unitprice: eachItem.unitprice - (eachItem.taxValue || 0) / eachItem.quantity,
          modifiers: [],
          smartModifiers: [],
        };

        if (eachItem.additionalInfo?.modifiers) {
          eachItem.additionalInfo.modifiers.forEach(eachModifier => {
            var tempModifierObject = {
              description: eachModifier.description,
              qty: eachModifier.quantity,
              unitprice: eachModifier.pricebeforetax / eachModifier.quantity,
            };
            tempItemObject.modifiers.push(tempModifierObject);
            tempItemObject.unitprice = tempItemObject.unitprice - eachModifier.pricebeforetax;
          });
        }

        fnbDataForTicketSummary.push(tempItemObject);
      }
    });
    this.setState({ fnbDataForTicketSummary }, callback);
  };

  scanBarCodeClick = buttonWrap => {
    console.log(buttonWrap, 'buttonWrap');
    if (buttonWrap === 'scanbarcode') {
      if (window.constant.USE_OLD_KIOSK_APP) {
        window.callbackObj.callEnableBarcodeScan('orderid');
      } else {
        window.callbackObj.callEnableBarcodeScan('orderid', window.constant.BOOKING_ID_LENGTH);
      }
      this.props.timerIncrement();
      this.setState({
        scanBarCodeBtnClick: true,
        manualBarCodeBtnClick: false,
      });
    } else if (buttonWrap === 'manualenterbarcode') {
      this.setState({
        manualBarCodeBtnClick: true,
        scanBarCodeBtnClick: false,
        keyboardInputClickManually: true,
      });
    }
    this.setState({
      barcodeModalSH: true,
      loginErrorMsg: '',
    });
  };

  calculateTotal = () => {
    // Use the shared utility
    return calculateTotal({
      ticketsDataForTicketSummary: this.state.ticketsDataForTicketSummary,
      fnbDataForTicketSummary: this.state.fnbDataForTicketSummary,
      bookingSummary: this.state.bookingSummary,
    });
  };

  setAllPayloads = getMethods => {
    // Use the shared utility
    return getAllPayloads(
      {
        bookingSummary: this.state.bookingSummary,
        ticketsDataForTicketSummary: this.state.ticketsDataForTicketSummary,
        fnbDataForTicketSummary: this.state.fnbDataForTicketSummary,
      },
      getMethods
    );
  };

  handlePrintTicket = () => {
    //show a Alert that the printing is in progress
    showAlert({
      html: `<p>The ticket is being printed. Please wait...</p>`,
      iconHtml: `<img src="/assets/images/info-icon.svg" alt="info" />`,
      showCancelButton: false,
      cancelButtonText: '',
      showConfirmButton: true,
      confirmButtonText: 'Okay',
      allowOutsideClick: false,
      allowEscapeKey: false,
      iconClasses: 'borderless',
      popupClasses: 'common-error-alert',
    });
    // Use the shared utility
    handlePrintTicketUtil({
      bookingSummary: this.state.bookingSummary,
      ticketsSummary: this.state.ticketsSummary,
      ticketsDataForTicketSummary: this.state.ticketsDataForTicketSummary,
      fnbDataForTicketSummary: this.state.fnbDataForTicketSummary,
      getAllPayloadsFn: getAllPayloads,
      calculateTotalFn: calculateTotal,
      formatShowTimeFn: formatShowTime,
      windowObj: window,
      constantObj: window.constant,
    });
  };

  render() {
    return (
      <>
        <Loader loader={this.state.loader} />
        <section className="pickup-tickets-page">
          <section className="pickup-tickets-wrapper">
            <CustomBanner voucherTitle={'Pickup Tickets'} titleLogo={''} title={''} subtitle={false} onBackBtnClick={this.handleBackBtn} renderAsHtml={false} rewardsRedeemText="" />
            <section className="content">
              {window.constant.PICKUP_TICKETS_ENTER_BOOKING_ID_MANUALLY === 'true' ? (
                <h2>
                  Scan your Booking Barcode <br /> OR <br /> Enter your Booking ID to collect your tickets
                </h2>
              ) : (
                <h2>Scan your Booking Barcode</h2>
              )}
              <div className="pickup-tickets-component">
                <div className="scan-btn paddingTop">
                  <button onClick={() => this.scanBarCodeClick('scanbarcode')} className="btn btnPrimary" title="CLICK TO SCAN BARCODE">
                    <span>CLICK TO SCAN BARCODE</span>
                    <BarCode />
                  </button>
                </div>
                {window.constant.PICKUP_TICKETS_ENTER_BOOKING_ID_MANUALLY === 'true' && (
                  <>
                    <p className="or-para">OR</p>
                    <div className="skip-text">
                      <p>
                        <button onClick={() => this.scanBarCodeClick('manualenterbarcode')} title="ENTER MANUALLY">
                          ENTER MANUALLY
                        </button>
                      </p>
                    </div>
                  </>
                )}
              </div>
            </section>
          </section>
        </section>
        <BarCodeModal
          parentState={this.state}
          closeIconClick={this.closeIconClick}
          keyBoardOnChange={this.keyBoardOnChange}
          keyBoardOnKeyPress={this.keyBoardOnKeyPress}
          keyBoardHandleShift={this.keyBoardHandleShift}
          clickKeyboardIcon={this.clickKeyboardIcon}
          disableSubmitBtn={this.disableSubmitBtn}
          userLogin={this.submitOrderId}
          keyBoardIcon={false}
          inputLabel="Enter your Booking ID"
          inputPlaceholder="Booking ID"
          inputValue={this.state.orderId}
        />
      </>
    );
  }
}

export default PickupTickets;
